import React from 'react';
import TotalsLine from '../../common/list/TotalsLine';
import { getNumberComma } from '../../../utils/numberUtils';
import { profitRateColor } from './costCalcShared';

// 원가 산출 합계 - 표 위에 떠 있던 Grid 박스 대신 가운뎃점으로 구분한 한 줄(TotalsLine)로.
// chance가 넘어오면 서버 확정값(원가산출 확정 후)을 쓰고, 없으면 편집 중 계산값(totalXxx)을 쓴다.
const CostSummary = ({
  chance,
  totalPurchase,
  totalSales,
  totalProfit,
  totalMargin,
}) => {
  const sales = chance?.totalSales ? chance.totalSales : totalSales;
  const purchase = chance?.totalPurchase ? chance.totalPurchase : totalPurchase;
  const profit = chance?.totalProfit ? chance.totalProfit : totalProfit;
  const margin = chance?.expBenefitRate !== undefined ? chance.expBenefitRate : totalMargin;

  return (
    <TotalsLine
      sx={{ justifyContent: 'flex-start', px: 0 }}
      items={[
        { label: '총 매출액', value: `${getNumberComma(sales)} 원` },
        { label: '총 매입액', value: `${getNumberComma(purchase)} 원` },
        { label: '총 매출이익', value: `${getNumberComma(profit)} 원` },
        { label: '이익율', value: `${margin ?? 0}%`, color: profitRateColor(margin) },
      ]}
    />
  );
};

export default CostSummary;
